import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import { cityActionId, DelegateInvitationEventActionId, stallListActionId, delegateInvitationTypeActionId, exhibitionActionId, toastError, toastSuccess } from "../../../utils/constants";
import { emailValidator } from "../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../utils/pagination";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getDelegate_All_B2b_MeetingList_action, getDelegate_B2B_Users_action, UpdateDelegate_All_B2b_Meeting_action } from "../../../actions/admin_module_action/delegate_All_B2B_Meeting_action/delegate_All_B2B_Meeting_action";
import Select from 'react-select';
import Footer from "../../../common_components/Footer";
import { Item } from "@hilla/react-components/Item.js";

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};
class Booked_All_B2B_Meeting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            countryList: [],
            All_B2B_MeetingList: [],
            deleteID: '',
            All_B2B_MeetingName: '',
            Status: '',
            isOpen2: false,
            is_add: false,
            All_B2B_MeetingID: '',
            diplayStatus: 1,
            exhibitionID: '',
            exhibitionList: [],
            InvitationEventId: '',
            InvitationEventList: [],
            ExhibitorList: [],
            VisitorList: [],
            DelegateList: [],
            Designation: '',
            CompanyName: '',
            CountryName: '',
            EmailID: '',
            Name: '',
            ExhibitorCurrentPage: 1,
            VisitorCurrentPage: 1,
            DelegateCurrentPage: 1,
        }
        this.ExhibitorUpdateItem = this.ExhibitorUpdateItem.bind(this)
        this.VisitorUpdateItem = this.VisitorUpdateItem.bind(this)
        this.DelegateUpdateItem = this.DelegateUpdateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '').then(() => {
        })
        this.getAll_B2B_MeetingList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === exhibitionActionId) {
                            this.setState({
                                exhibitionList: data.data.length > 0 ? data.data : [],
                                isLoading: false
                            })
                        }
                        if (actionID === DelegateInvitationEventActionId) {
                            if (data.data != '') {
                                const Array = []
                                data.data.map(item => {
                                    Array.push({ label: item.Name, value: item.InvitationEventID })
                                })
                                this.setState({
                                    InvitationEventList: Array
                                })
                            } else {
                                this.setState({
                                    InvitationEventList: data.data
                                })
                            }
                        }
                        resolve(true)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getAll_B2B_MeetingList() {
        this.setState({ isLoading: true })
        const { exhibitionID, InvitationEventId, Designation, CompanyName, CountryName, EmailID, Name } = this.state

        this.props.getDelegate_B2B_Users_action(exhibitionID, Designation, CompanyName, CountryName, EmailID, Name)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        ExhibitorList: data.ExhibitorData,
                        VisitorList: data.VisitorData,
                        DelegateList: data.DelegateData,
                        isLoading: false
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            Designation: '',
            CompanyName: '',
            CountryName: '',
            EmailID: '',
            Name: '',
        })
        setTimeout(() => {
            this.state.InvitationEventId != '' && this.getAll_B2B_MeetingList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/delegateAll_B2B_MeetingAU', { state: { is_add: true, } })
    }

    handleUpdate(id, value) {
        if (value == 'isUpdate') {
            this.props.navigate('/delegateAll_B2B_MeetingAU', { state: { is_update: true, is_view: false, All_B2B_MeetingID: id } })
        } else {
            this.props.navigate('/delegateAll_B2B_MeetingAU', { state: { is_update: true, is_view: true, All_B2B_MeetingID: id } })
        }
    }

    insertUpdateAll_B2B_Meeting(id) {
        const { ExhibitorList, VisitorList, DelegateList, VIPList, GuestList, SpeakerList, GovtList, InvitationEventId, exhibitionID } = this.state
        const selectedData = []
        function mapSelectedData(array, InvitationEventID) {
            if (array != '') {
                array.map((item) => {
                    if (item.isChecked || item.ActionID == 3) {
                        selectedData.push(
                            {
                                InvitationEventID: InvitationEventID,
                                RegistrationID: item.RegistrationID,
                                AccountTypeID: item.AccountTypeID,
                                ActionID: item.ActionID,
                                EmailID: item.EmailID,
                            }
                        )
                    }
                })
            }
        }
        for (let i = 0; i < InvitationEventId.length; i++) {
            mapSelectedData(ExhibitorList, InvitationEventId[i]['value'])
            mapSelectedData(VisitorList, InvitationEventId[i]['value'])
            mapSelectedData(DelegateList, InvitationEventId[i]['value'])
            mapSelectedData(VIPList, InvitationEventId[i]['value'])
            mapSelectedData(GuestList, InvitationEventId[i]['value'])
            mapSelectedData(SpeakerList, InvitationEventId[i]['value'])
            mapSelectedData(GovtList, InvitationEventId[i]['value'])
        }
        console.log("selectedData---------------->", selectedData)
        this.props.insertUpdate_InvitationAllocation_action(exhibitionID, selectedData)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("Data updated successfully")
                    setTimeout(() => {
                        this.getAll_B2B_MeetingList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(id) {
        const { } = this.state
        this.setState({ deleteID: id })
        this.setState({ isOpen: true, })
    }

    oCheckbox(event, i, value) {
        const { ExhibitorList, VisitorList, DelegateList, VIPList, GuestList, SpeakerList, GovtList, InvitationEventId } = this.state
        function valueCheked(array) {
            if (array != '') {
                array.map((item, index) => {
                    if (i === index) {
                        item.isChecked = event
                        if (item.ActionID == 1 || item.ActionID == 3) {
                            if (item.isChecked) {
                                item.ActionID = 1
                            } else {
                                item.ActionID = 3
                            }
                        } else if (item.ActionID == 0 || item.ActionID == 2) {
                            if (item.isChecked) {
                                item.ActionID = 2
                            } else {
                                item.ActionID = 0
                            }
                        }
                    }
                })
                return array
            }
        }
        if (value == 'Exhibitor') {
            this.setState({ ExhibitorList: valueCheked(ExhibitorList) })
        } else if (value == 'Visitor') {
            this.setState({ VisitorList: valueCheked(VisitorList) })
        } else if (value == 'Delegate') {
            this.setState({ DelegateList: valueCheked(DelegateList) })
        }
    }

    ExhibitorUpdateItem(item) {
        const { ExhibitorList } = this.state
        this.setState({ ExhibitorCurrentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = ExhibitorList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(ExhibitorList.length / recordsPerPage)
    }

    VisitorUpdateItem(item) {
        const { VisitorList } = this.state
        this.setState({ VisitorCurrentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = VisitorList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(VisitorList.length / recordsPerPage)
    }

    DelegateUpdateItem(item) {
        const { DelegateList } = this.state
        this.setState({ DelegateCurrentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DelegateList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DelegateList.length / recordsPerPage)
    }

    render() {
        const { isOpen, isLoading, InvitationEventId, Designation, CompanyName, CountryName, EmailID, Name, ExhibitorList, VisitorList, DelegateList, ExhibitorCurrentPage, VisitorCurrentPage, DelegateCurrentPage } = this.state

        const recordsPerPage1 = 10;
        const indexOfLastRecord1 = ExhibitorCurrentPage * recordsPerPage1;
        const indexOfFirstRecord1 = indexOfLastRecord1 - recordsPerPage1
        const currentRecords1 = ExhibitorList.slice(indexOfFirstRecord1, indexOfLastRecord1);
        const nPages1 = Math.ceil(ExhibitorList.length / recordsPerPage1)

        const recordsPerPage2 = 10;
        const indexOfLastRecord2 = VisitorCurrentPage * recordsPerPage2;
        const indexOfFirstRecord2 = indexOfLastRecord2 - recordsPerPage2
        const currentRecords2 = VisitorList.slice(indexOfFirstRecord2, indexOfLastRecord2);
        const nPages2 = Math.ceil(VisitorList.length / recordsPerPage2)

        const recordsPerPage3 = 10;
        const indexOfLastRecord3 = DelegateCurrentPage * recordsPerPage3;
        const indexOfFirstRecord3 = indexOfLastRecord3 - recordsPerPage3
        const currentRecords3 = DelegateList.slice(indexOfFirstRecord3, indexOfLastRecord3);
        const nPages3 = Math.ceil(DelegateList.length / recordsPerPage3)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row">
                            <div className="step-name">
                                <p>All B2B Meeting's</p>
                            </div>
                        </div>
                        <div className="m-3">
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label >Company Name</label>
                                    <input className="form-control"
                                        value={CompanyName}
                                        onChange={(e) => this.setState({ CompanyName: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >Person Name</label>
                                    <input className="form-control"
                                        value={Name}
                                        onChange={(e) => this.setState({ Name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >Designation</label>
                                    <input className="form-control"
                                        value={Designation}
                                        onChange={(e) => this.setState({ Designation: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >EmailID</label>
                                    <input className="form-control"
                                        value={EmailID}
                                        onChange={(e) => this.setState({ EmailID: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3 mt-2">
                                    <label >Country Name</label>
                                    <input className="form-control"
                                        value={CountryName}
                                        onChange={(e) => this.setState({ CountryName: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3 mt-2" style={{ textAlign: 'left' }}>
                                    <label>&emsp;</label>
                                    <button Event="button" className="btn ad-fil-btn"
                                        onClick={e => this.getAll_B2B_MeetingList()}
                                    >
                                        Search
                                    </button>
                                    <button Event="button" className="btn ad-fil-btn"
                                        onClick={e => this.clearSearch()}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-12 p-0 mt-4">
                                <div className="table-responsive">
                                    <p className="m-0"><strong> Exhibitor's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{width:'50px'}}>Invite</th>
                                                <th >Company Name</th>
                                                <th >Person Name</th>
                                                <th >Designation</th>
                                                <th >Email</th>
                                                <th >Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentRecords1.length > 0 ? <>{
                                                    currentRecords1.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Exhibitor')}
                                                                />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>

                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                ExhibitorList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages1}
                                                        currentPage={ExhibitorCurrentPage}
                                                        setCurrentPage={this.ExhibitorUpdateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong> Visitor's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{width:'50px'}}>Invite</th>
                                                <th >Company Name</th>
                                                <th >Person Name</th>
                                                <th >Designation</th>
                                                <th >Email</th>
                                                <th >Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentRecords2.length > 0 ? <>{
                                                    currentRecords2.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Visitor')}
                                                                />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                VisitorList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages2}
                                                        currentPage={VisitorCurrentPage}
                                                        setCurrentPage={this.VisitorUpdateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong> Delegate's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{width:'50px'}}>Invite</th>
                                                <th>Company Name</th>
                                                <th>Person Name</th>
                                                <th>Designation</th>
                                                <th>Email</th>
                                                <th>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentRecords3.length > 0 ? <>{
                                                    currentRecords3.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Delegate')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                DelegateList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages3}
                                                        currentPage={DelegateCurrentPage}
                                                        setCurrentPage={this.DelegateUpdateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3" style={{ margin: 'auto', width: '98%' }}>
                                <div class="col-md-12">
                                    {InvitationEventId != '' && <button type="button" class="btn btn-primary rounded-0" style={{ float: 'right' }}
                                        onClick={() => this.insertUpdateAll_B2B_Meeting()}>
                                        Save
                                    </button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '10%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-danger">Do you really want to delete this record?</h5>

                                {/* <button Event="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button Event="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteDelegateAll_B2B_Meeting(this.state.deleteID)}
                                    >Yes</button>
                                    <button Event="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getDelegate_All_B2b_MeetingList_action, getDelegate_B2B_Users_action, UpdateDelegate_All_B2b_Meeting_action })(Booked_All_B2B_Meeting));

